import notifications from '@/api/notification/notifications'

export default {
  notifications,
}
